<template>
  <div v-if="data" class="info-page">
    <div class="info-page-body">
      <div class="info-page-body-top flex">
        <div v-if="data.image" class="info-page-body-top-img flex-shrink" :style="{backgroundImage: 'url(' +'https://img.libraryplus.bjadks.com/'+ data.image + ')'}" />

        <div v-else class="info-page-body-top-img flex-shrink default-img-cover" />

        <div v-if="catalogName==='人物'" class="info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.name }}</p>
          <span v-if="data.sex" class="item flex">
            <p class="font-14 key flex-shrink">性别：</p>
            <p class="font-14 value flex-1">{{ data.sex }}</p>
          </span>
          <span v-if="data.nativePlace" class="item flex">
            <p class="font-14 key flex-shrink">籍贯：</p>
            <p class="font-14 value flex-1">{{ data.nativePlace }}</p>
          </span>
          <span v-if="data.bronDate" class="item flex">
            <p class="font-14 key flex-shrink">出生日期：</p>
            <p class="font-14 value flex-1">{{ data.bronDate }}</p>
          </span>
          <span v-if="data.deathDate" class="item flex">
            <p class="font-14 key flex-shrink">逝世日期：</p>
            <p class="font-14 value flex-1">{{ data.deathDate }}</p>
          </span>
        </div>
        <div v-else-if="catalogName==='地点'" class="info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.name }}</p>
          <span v-if="data.coordinate" class="item flex">
            <p class="font-14 key flex-shrink">地点位置：</p>
            <p class="font-14 value flex-1">{{ data.coordinate }}</p>
          </span>
          <span v-if="data.mapPlace" class="item flex">
            <p class="font-14 key flex-shrink">坐标：</p>
            <p class="font-14 value flex-1">{{ data.mapPlace }}</p>
          </span>
        </div>
        <div v-else-if="catalogName==='机构'" class="info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.name }}</p>
          <span v-if="data.coordinate" class="item flex">
            <p class="font-14 key flex-shrink">机构地点：</p>
            <p class="font-14 value flex-1">{{ data.coordinate }}</p>
          </span>
          <span v-if="data.mapPlace" class="item flex">
            <p class="font-14 key flex-shrink">坐标：</p>
            <p class="font-14 value flex-1">{{ data.mapPlace }}</p>
          </span>
          <span v-if="data.createTime" class="item flex">
            <p class="font-14 key flex-shrink">建立时间：</p>
            <p class="font-14 value flex-1">{{ data.createTime }}</p>
          </span>
        </div>
        <div v-else-if="catalogName==='事件'" class="info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.name }}</p>
          <span v-if="data.startDate" class="item flex">
            <p class="font-14 key flex-shrink">开始时间：</p>
            <p class="font-14 value flex-1">{{ data.startDate }}</p>
          </span>
          <span v-if="data.endDate" class="item flex">
            <p class="font-14 key flex-shrink">结束时间：</p>
            <p class="font-14 value flex-1">{{ data.endDate }}</p>
          </span>
          <span v-if="data.place" class="item flex">
            <p class="font-14 key flex-shrink">地点：</p>
            <p class="font-14 value flex-1">{{ data.place }}</p>
          </span>
          <span v-if="data.mapPlace" class="item flex">
            <p class="font-14 key flex-shrink">地点坐标：</p>
            <p class="font-14 value flex-1">{{ data.mapPlace }}</p>
          </span>
        </div>
      </div>

      <div class="info-page-body-des">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">{{ catalogName }}介绍</p>
        </div>
        <div class="info-page-body-des-text">
          <p class="font-16 letter-spacing">{{ data.description }}</p>
        </div>
      </div>
      <div v-if="timeTrackData.length" class="info-page-body-des">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">时空轨迹</p>
        </div>
        <time-track :tracks="timeTrackData" />
      </div>
      <!--      v-show="this.nodes.length>0"-->
      <div class="info-page-body-des">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">{{ catalogName }}图谱</p>
        </div>
        <div class="relation-page-body safe-with">
          <div class="relation-page-body-tools flex-row-center">
            <span class="relation-page-body-tools-item flex-row-center">
              <p class="font-14 font-color-fff">关系层级：</p>
              <el-select v-model="deepValue" placeholder="请选择" @change="deepValueChange">
                <el-option
                  v-for="item in deepOpt"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </span>
            <span class="relation-page-body-tools-item flex-row-center">
              <p class="font-14 font-color-fff">关系实体：</p>
              <el-select ref="selectAppType" v-model="typeValue" multiple collapse-tags placeholder="请选择" @change="typeValueChange">
                <el-option
                  v-for="item in typeOpt"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </span>
          </div>
          <!-- <div id="relation-page-body-echar" style="height: 100%;" /> -->
          <relation-graph ref="rg" :options="graphOptions">
            <div slot="node" slot-scope="{node}">
              <el-popover
                width="300"
                placement="right"
                trigger="hover"
              >
                <div
                  slot="reference"
                  style="border-radius: 50%;cursor: pointer; overflow: hidden;border: 3px solid #EBEEF5;"
                  class="flex-column-center position-relative"
                  :style="{width: (node.width)+'px',height: node.height+'px',borderColor:node.color}"
                  @click="getNodesClick(node.id)"
                >
                  <!--                  <el-image class="node-img" :src="'http://img.libraryplus.bjadks.com/'+node.data.image" style="border-radius: 50%;border-width: 3px; user-select: none;" :style="{width: node.data.size+'px',height: node.data.size+'px'}" />-->
                  <el-image v-if="node.data.image" class="node-img" :src="'http://img.libraryplus.bjadks.com/'+node.data.image" style="border-radius: 50%;border-width: 3px; user-select: none;" :style="{width: node.data.size+'px',height: node.data.size+'px'}" />
                  <div v-else class="node-img default-img-cover" style="border-radius: 50%;border-width: 3px; user-select: none;" :style="{width: node.data.size+'px',height: node.data.size+'px'}" />
                  <!--                  <div class="linear" :style="{height:parseInt(node.data.size)/2+'px',width:node.data.size+'px'}" style="position: absolute;bottom: 0">-->
                  <!--                    <span class="text-line1" :style="{lineHeight:parseInt(node.data.size)/2+'px'}" style="color: #FFFFFF;overflow: hidden">{{ node.text }}</span>-->
                  <!--                  </div>-->
                  <div class="linear" :style="{height:parseInt(node.data.size)/2+'px',width:node.data.size+'px'}" style="position: absolute;bottom: 0">
                    <span class="text-line1 linear-text" :style="{lineHeight:parseInt(node.data.size)/2+'px'}" style="color: #FFFFFF;overflow: hidden">{{ node.text }}</span>
                  </div>
                </div>
                <!--                <el-card shadow="never" style="border: none!important;">-->
                <div style="height: 300px;overflow:hidden;">
                  <el-scrollbar wrap-class="scrollbar-wrapper">

                    <el-form v-if="node.type=='person'" label-suffix=":" style="margin: 20px">
                      <el-form-item v-if="node.text" label="姓名">
                        {{ node.text }}
                      </el-form-item>
                      <el-form-item v-if="node.data.sex" label="性别">
                        {{ node.data.sex }}
                      </el-form-item>
                      <el-form-item v-if="node.data.bronDate" label="出生年月">
                        {{ node.data.bronDate }}
                      </el-form-item>
                      <el-form-item v-if="node.data.nativePlace" label="籍贯">
                        {{ node.data.nativePlace }}
                      </el-form-item>
                      <el-form-item v-if="node.data.description" label="人物简介">
                        {{ node.data.description }}
                      </el-form-item>
                    </el-form>
                    <el-form v-else-if="node.type=='event'" label-suffix=":" style="margin: 20px">
                      <el-form-item v-if="node.text" label="名称">
                        {{ node.text }}
                      </el-form-item>

                      <el-form-item v-if="node.data.coordinate" label="发生地点">
                        {{ node.data.coordinate }}
                      </el-form-item>
                      <el-form-item label="大事件">
                        {{ node.data.majorEvent?'是':'否' }}
                      </el-form-item>
                      <el-form-item label="时间轨迹">
                        {{ node.data.trajectory?'是':'否' }}
                      </el-form-item>
                      <el-form-item v-if="node.data.startDate" label="开始时间">
                        {{ node.data.startDate }}
                      </el-form-item>
                      <el-form-item v-if="node.data.endDate" label="开始时间">
                        {{ node.data.endDate }}
                      </el-form-item>
                      <el-form-item v-if="node.data.description" label="事件描述">
                        {{ node.data.description }}
                      </el-form-item>
                    </el-form>
                    <el-form v-else-if="node.type=='place'" label-suffix=":" style="margin: 20px">
                      <el-form-item v-if="node.text" label="名称">
                        {{ node.text }}
                      </el-form-item>
                      <el-form-item v-if="node.data.coordinate" label="地址">
                        {{ node.data.coordinate }}
                      </el-form-item>
                      <el-form-item v-if="node.data.mapPlace" label="坐标">
                        {{ node.data.mapPlace }}
                      </el-form-item>

                      <el-form-item v-if="node.data.description" label="地点描述">
                        {{ node.data.description }}
                      </el-form-item>
                    </el-form>
                    <el-form v-else-if="node.type=='organization'" label-suffix=":" style="margin: 20px">
                      <el-form-item v-if="node.text" label="名称">
                        {{ node.text }}
                      </el-form-item>

                      <el-form-item v-if="node.data.place" label="地点">
                        {{ node.data.place }}
                      </el-form-item>

                      <el-form-item v-if="node.data.description" label="机构描述">
                        {{ node.data.description }}
                      </el-form-item>
                    </el-form>

                  </el-scrollbar>
                </div>
                <!--                </el-card>-->
              </el-popover>
            </div>
          </relation-graph>
        </div>
      </div>
      <div v-if="relationSourceTotal>0" class="info-page-body-des">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">相关馆藏</p>
        </div>
        <relation-source :total="relationSourceTotal" :list="relationSources" @pageChange="pageChange" @linkcate="toSourceCate" @link="toSource" />
      </div>
      <div v-if="nextBook" class="info-page-body-bottom flex-row-center">
        <p class="font-14 cursor" @click="toNext">下一篇：{{ nextBook.name }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import relationSource from '@/components/relationSource/index.vue'
import timeTrack from '@/components/timeTrack/leaflet.vue'
import RelationGraph from 'relation-graph'
import api from '@/api/index.js'
export default {
  components: {
    RelationGraph,
    timeTrack,
    relationSource
  },
  data() {
    return {
      relationSourceTotal: 0,
      relationSourcePage: 1,
      relationSources: [],
      timeTrackData: [],
      nextBook: null,
      curIndex: 0,
      catalogName: '',
      list: [],
      data: null,
      id: 0,
      graphOptions: {
        disableDragNode: false,
        defaultNodeFontColor: '#fff',
        allowShowMiniToolBar: false,
        backgroundColor: '#162336',
        'defaultLineShape': 5,
        min_per_width: 800,
        max_per_width: 1000,
        min_per_height: 800,
        max_per_height: 1000
      },
      deepOpt: [{
        value: '1',
        label: '1级关系'
      }, {
        value: '2',
        label: '2级关系'
      }, {
        value: '3',
        label: '3级关系'
      }],
      deepValue: '1',
      typeOpt: [{
        value: 'person',
        label: '人物'
      }, {
        value: 'event',
        label: '事件'
      }, {
        value: 'organization',
        label: '机构'
      }, {
        value: 'place',
        label: '地点'
      }],
      typeValue: [],
      nodes: [],
      relations: []
    }
  },
  methods: {
    showInfo(curData, index, list, catalogName) {
      this.catalogName = catalogName
      this.data = curData
      this.id = this.data.id
      this.list = list
      this.request()
      if (this.catalogName === '人物') {
        this.reqeustTimeTrack()
      }
      if (index + 1 < list.length) {
        this.nextBook = list[index + 1]
        this.curIndex = index
      } else {
        this.nextBook = null
      }
    },
    showInfoId(id, list, catalogName) {
      this.catalogName = catalogName
      this.id = id
      this.list = []
      this.list = this.list.concat(list)
      this.getDataId()
    },
    getDataId() {
      if (this.catalogName === '人物') {
        api.person({
          id: this.id,
          page: 1,
          limit: 1
        }).then(res => {
          if (res.code === 2000) {
            this.data = res.items.data[0]
            this.request()
            this.list.unshift(this.data)
            if (this.list.length > 1) {
              this.nextBook = this.list[1]
              this.curIndex = 0
            } else {
              this.nextBook = null
            }
          }
        })
        this.reqeustTimeTrack()
      } else if (this.catalogName === '地点') {
        api.place({
          id: this.id,
          page: 1,
          limit: 1
        }).then(res => {
          if (res.code === 2000) {
            this.data = res.items.data[0]
            this.request()
            this.list.unshift(this.data)
            if (this.list.length > 1) {
              this.nextBook = this.list[1]
              this.curIndex = 0
            } else {
              this.nextBook = null
            }
          }
        })
      } else if (this.catalogName === '事件') {
        api.event({
          id: this.id,
          page: 1,
          limit: 1
        }).then(res => {
          if (res.code === 2000) {
            this.data = res.items.data[0]
            this.request()
            this.list.unshift(this.data)
            if (this.list.length > 1) {
              this.nextBook = this.list[1]
              this.curIndex = 0
            } else {
              this.nextBook = null
            }
          }
        })
      } else if (this.catalogName === '机构') {
        api.organization({
          id: this.id,
          page: 1,
          limit: 1
        }).then(res => {
          if (res.code === 2000) {
            this.data = res.items.data[0]
            this.request()
            this.list.unshift(this.data)
            if (this.list.length > 1) {
              this.nextBook = this.list[1]
              this.curIndex = 0
            } else {
              this.nextBook = null
            }
          }
        })
      }
    },
    getNodesClick(id) {
      this.id = id
      this.request()
    },
    pageChange(v) {
      this.relationSourcePage = v
      this.requestRelation()
    },
    async requestRelation() {
      const res = await api.sourceList({
        entityId: this.id,
        limit: 10,
        page: this.relationSourcePage
      })
      this.relationSources = res.items.data
      this.relationSourceTotal = res.items.totalCount
    },
    async request() {
      const res = await api.nodeRelation({
        direction: 0,
        startId: this.id,
        level: this.deepValue,
        endLabel: this.typeValue.join(',')
      })
      const node = []
      res.items.nodes.forEach(item => {
        const name = {
          id: item.id + '',
          text: item.property.name,
          color: item.property.color,
          borderColor: item.property.color,
          data: item.property,
          type: item.label[0],
          height: parseInt(item.property.size) + 3,
          width: parseInt(item.property.size) + 3
        }
        node.push(name)
      })
      this.nodes = node

      const relation = []
      res.items.relations.forEach(item => {
        const name = {
          from: item.startId + '',
          to: item.endId + '',
          text: item.typeName + '',
          color: item.property.color,
          lineWidth: item.property.lineWidth,
          // 'useTextPath': true,
          'isHideArrow': false,
          'showStartArrow': false,
          'showEndArrow': true,
          data: item.property,
          lineShape: 5
        }
        relation.push(name)
      })
      this.relations = relation
      this.setGraphData()
      this.requestRelation()
    },
    async reqeustTimeTrack() {
      const res = await api.nodeRelation({
        endLabel: 'event',
        direction: 0,
        startId: this.id,
        level: 1,
        trajectory: 1
      })
      const ary = res.items.nodes.filter(v => {
        if (v.label[0] === 'event') {
          return v
        }
      }).sort(this.compareDates)
      this.timeTrackData = ary
    },
    compareDates(a, b) {
      var dateA = new Date(a.property.startDate)
      var dateB = new Date(b.property.startDate)
      return dateA - dateB
    },
    setGraphData() {
      if (this.nodes.length === 0) {
        this.requestId()
        return
      }
      const relation_graph = { 'rootId': 'id', nodes: this.nodes, lines: this.relations }

      this.$refs.rg.setJsonData(relation_graph, (graphInstance) => {
        // 这些写上当图谱初始化完成后需要执行的代码
      })
    },
    async requestId() {
      const res = await api.relation({
        id: this.id
      })
      const node = []
      res.items.nodes.forEach(item => {
        const name = {
          id: item.id + '',
          text: item.property.name,
          color: item.property.color,
          borderColor: item.property.color,
          data: item.property,
          type: item.label[0],
          height: parseInt(item.property.size) + 3,
          width: parseInt(item.property.size) + 3
        }
        node.push(name)
      })
      this.nodes = node

      const relation = []
      res.items.relations.forEach(item => {
        const name = {
          from: item.startId + '',
          to: item.endId + '',
          text: item.typeName + '',
          color: item.property.color,
          lineWidth: item.property.lineWidth,
          // 'useTextPath': true,
          'isHideArrow': false,
          'showStartArrow': false,
          'showEndArrow': true,
          data: item.property,
          lineShape: 5

        }
        relation.push(name)
      })
      this.relations = relation
      this.setGraphData()
    },
    deepValueChange(v) {
      this.request()
    },
    typeValueChange(v) {
      setTimeout(() => {
        this.$refs.selectAppType.blur()
        this.request()
      }, 1000)
    },

    toNext() {
      this.curIndex += 1
      if (this.curIndex + 1 < this.list.length) {
        this.nextBook = this.list[this.curIndex + 1]
      } else {
        this.nextBook = null
      }
      this.data = this.list[this.curIndex]
      this.id = this.data.id
      this.deepValue = 2
      this.typeValue = []
      this.request()
      window.scrollTo(0, 0)
    },
    toSource(v) {
      const page = this.$router.resolve({
        path: '/source',
        query: {
          cateId: v.catalogId,
          sourceId: v.id
        }
      })
      window.open(page.href, '_blank')
    },
    toSourceCate(v) {
      const page = this.$router.resolve({
        path: '/source',
        query: {
          cateId: v.catalogId
        }
      })
      window.open(page.href, '_blank')
    }
  }
}
</script>
<style>
.el-popover {
  padding: 0px !important;
}
</style>
<style  scoped>
 .el-popover {

  padding: 0px !important;

}
.info-page {
  padding: 20px 0 60px;
}
 .linear{
   background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); display: flex; align-items: center; justify-content: center;
 }
 .linear-text{
   line-height: 140%!important; display: block; font-size: 12px!important; padding: 0 5%; text-shadow: 0px 1px 2px rgba(0,0,0,1);
 }
.info-page-body-top {
  margin-bottom: 30px;
  overflow: hidden;
}

.info-page-body-top-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 340px;
  height: 240px;
  margin-right: 20px;
  border-radius: 3px;
}

.info-page-body-top-tit .tit {
  color: #1A1A1A;
  line-height: 36px;
  margin-bottom: 10px;
}

.info-page-body-top-tit .item {
  margin-bottom: 10px;
}

.info-page-body-top-tit .item .key {
  width: 80px;
  line-height: 22px;
  color: #767676;
}

.info-page-body-top-tit .item .value {
  line-height: 22px;
  color: #1A1A1A;
  word-break: break-all;
}

.info-page-body-files {
  margin-bottom: 30px;
}

.info-page-body-files-head {
  height: 50px;
}

.info-page-body-files-head .line {
  background: #B21F12;
  width: 4px;
  height: 16px;
  margin-right: 6px;
}

.info-page-body-files-head p {
  color: #B21F12;
}

.info-page-body-files-list {
  flex-wrap: wrap;
}

.info-page-body-files-list .item {
  width: calc(50% - 5px);
  height: 40px;
  border-radius: 5px;
  background: #F7F7F7;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 15px;
}

.info-page-body-files-list .item:nth-child(2n) {
  margin-right: 0;
}

.info-page-body-files-list .item img {
  margin-right: 10px;
}

.info-page-body-files-list .item .tit {
  color: #1A1A1A;
}

.info-page-body-files-list .item .btn {
  color: #767676;
  margin-left: 10px;
}

.info-page-body-des {
  margin-bottom: 30px;
}

.info-page-body-des-text p{
  line-height: 32px;
  color: #1A1A1A;
  white-space: pre-wrap;
  word-break: break-all;
}

.info-page-body-bottom {
  margin-top: 60px;
  border-top: 1px solid #eee;
  height: 50px;
}

.info-page-body-bottom p {
  color: #1A1A1A;
}
.safe-with {
  width: 970px;
  margin: 0 auto;
}
.relation-page-body {
  height: 700px;
  background: #162336;
  border-radius: 5px;
  margin-top: 20px;
  margin-bottom: 60px;
  position: relative;
}

.relation-page-body-tools {
  padding: 10px;
  position: absolute;
  z-index: 9999;
}

.relation-page-body-tools-item {
  margin-right: 20px;
}

.node-img {
  pointer-events: none;
}
</style>
<style lang="scss" scoped>

/deep/ .el-form-item {
  margin-bottom: 10px!important;
}
/deep/ .el-form-item__content {
  line-height: 25px;
  position: relative;
  font-size: 14px;
}

/deep/ .el-form-item__label {
   text-align: right;
   vertical-align: middle;
   float: left;
   font-size: 14px;
   color: #606266;
  line-height: 25px;
   padding: 0 12px 0 0;
   box-sizing: border-box;
 }
/deep/ .el-input__select {
  height: 30px;
}
/deep/ .el-input__inner {
  width: 140px;
  background: rgba(255, 255, 255, 0.2) !important;
  color: #fff;
  border: none;
}
.scrollbar-wrapper {
  overflow-x: hidden !important;
}

.el-scrollbar__bar.is-vertical {
  right: 0px !important;
}

.el-scrollbar {
  height:317px !important;
}
</style>
